//React components 
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
//Components 
import TransactionPill from "./TransactionPill";
import TransactionHistory from "./TransactionHistory";
import Navbar from '../NavBar/Navbar';
import Modal from 'react-bootstrap/Modal';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import ErrorAlert from '../Alerts/ErrorAlert';
import OrderDetails from '../Orders/OrderDetails';
import Footer from '../Footer/Footer';
import SupportBot from '../SupportBot/SupportBot';
//Utils 
import Socket from '../utils/Socket.config';
//External modules 
import moment from 'moment-timezone';
//Api 
import { OrdersFetchAPI } from '../../api/Orders';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { PosIntegrationFetchAPI } from '../../api/PosIntegrations';
import { PedidosYaFetchAPI } from '../../api/PedidosYa';
import { UberEatsFetchAPI } from '../../api/UberEats';
import { notifyAndroidDashboardReady } from '../../utils/AndroidSessionBridge';
//img
import empty from '../img/icons/empty.png';
import update from '../img/icons/update-list.png'
import { RenderIf } from '../utils/RenderIf';
//CSS
import "./transaction.css"


function Transactions() {
   //Params
   let { business_code } = useParams();
   //We get the user data 
   let user = JSON.parse(localStorage.getItem('user'))
   let token = localStorage.getItem('x-access-token');
   //States
   const [change_status, setchange_status] = useState(0)
   const [branchOrdersData, setBranchOrdersData] = useState([]);
   const [dataBranchoffice, setDataBranchoffice] = useState(0)
   const [temporal, setTemporal] = useState([]);
   const [userBranchoffices, setUserBranchs] = useState([]);
   const [userBusiness, setUserBusiness] = useState({});
   const [posIntegrationParams, setPosIntegrationParams] = useState([]);
   const [selectedBranch, setSelectedBranch] = useState({
      code: 0
   });
   const [temporalOrdersData, setTemporalOrdersData] = useState([]);
   const [detailOrder, setDetailOrder] = useState();
   const [order_type, setOrderType] = useState("temporal")
   const [modalShow, setModalShow] = useState(false);
   const [reload, setReLoad] = useState(false);
   const [deepLinkHandled, setDeepLinkHandled] = useState(false);
   const [pedidosYaStatus, setPedidosYaStatus] = useState("CLOSED");
   const [uberEatsStatus, setUberEatsStatus] = useState("OFFLINE");
   //We get the actual date 
   const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')
   //Functions to show and hide the modal 
   const handleCloseModal = () => setModalShow(false);
   const handleShowModal = () => setModalShow(true);
   const getOrderIdentity = (order) => [
      order?._id,
      order?.id,
      order?.code,
      order?.order_code,
      order?.temp_order_code,
      order?.temporal_order_code,
      order?.transaction_code,
   ].filter((value) => value !== undefined && value !== null && value !== "").map(String);

   const sameOrderIdentity = (left, right) => {
      const leftIds = getOrderIdentity(left);
      const rightIds = getOrderIdentity(right);
      return leftIds.some((id) => rightIds.includes(id));
   }

   const getApprovalRequestType = (order) => {
      const explicitType = order?._approval_request_type || order?.request_type || order?.notification_type;
      if (String(explicitType).toLowerCase().includes("devol")) return "Devolucion";
      if (String(explicitType).toLowerCase().includes("discount") || String(explicitType).toLowerCase().includes("descuento")) return "Descuento";
      if (order?.is_devolution_notification === true) return "Devolucion";
      if (order?.is_discount_notification === true) return "Descuento";
      if (order?.order_type === "devolution" || order?.invoice_type === "devolution") return "Devolucion";
      if (Number(order?.discount || 0) > 0 || Number(order?.unit_discount || 0) > 0 || (Array.isArray(order?.discounts) && order.discounts.length > 0)) return "Descuento";
      return null;
   }

   const isApprovalOrder = (order) => Boolean(getApprovalRequestType(order));

   const unwrapSocketOrder = (payload) => payload?.order || payload?.temp_order || payload?.tempOrder || payload?.data || payload;

   const setTemporalOrdersDataSafe = (nextOrders, handledOrder = detailOrder) => {
      const nextList = Array.isArray(nextOrders) ? [...nextOrders] : [];
      if (!handledOrder || getOrderIdentity(handledOrder).length === 0) {
         setTemporalOrdersData(nextList);
         return;
      }

      setTemporalOrdersData((prevOrders) => prevOrders.filter((order) => !sameOrderIdentity(order, handledOrder)));
   }

   const upsertTemporalOrder = (payload) => {
      const order = unwrapSocketOrder(payload);
      const requestType = getApprovalRequestType(order);
      if (!requestType) return;

      const normalizedOrder = normalizeApprovalOrder(order, requestType);
      const selectedBranchCode = localStorage.getItem('branchoffice_selected');
      const branchCode = normalizedOrder?.branchoffice?.code || normalizedOrder?.branchoffice_code || normalizedOrder?.branch_code;
      const canAccessBranch = !branchCode || user?.branchoffices?.some(branch => String(branch.code) === String(branchCode));
      const branchMatchesSelection = !branchCode || selectedBranchCode === "0" || selectedBranchCode === 0 || String(selectedBranchCode) === String(branchCode);

      if (!canAccessBranch || !branchMatchesSelection) return;

      setTemporalOrdersData((prevOrders) => {
         const nextOrders = prevOrders.filter((item) => !sameOrderIdentity(item, normalizedOrder));
         return [normalizedOrder, ...nextOrders];
      });
   }

   const removeTemporalOrder = (payload) => {
      const order = unwrapSocketOrder(payload);
      setTemporalOrdersData((prevOrders) => prevOrders.filter((item) => !sameOrderIdentity(item, order)));
   }

   const getApprovalDeepLinkParams = () => {
      if (typeof window === "undefined") return null;

      const searchParams = new URLSearchParams(window.location.search);
      const branchCode = searchParams.get('branchoffice_code') || searchParams.get('branch_code') || searchParams.get('branch');
      const tempOrderCode = searchParams.get('temp_order_code') || searchParams.get('order_code');
      const requestType = searchParams.get('request_type');

      if (!branchCode || !tempOrderCode) return null;

      return {
         branchCode,
         tempOrderCode,
         requestType
      };
   }

   const clearApprovalDeepLinkParams = () => {
      if (typeof window === "undefined") return;

      window.history.replaceState({}, document.title, window.location.pathname);
   }


   useEffect(() => {
      if (token && user && business_code && typeof window !== "undefined" && !window.location.pathname.startsWith('/login')) {
         notifyAndroidDashboardReady();
      }
   }, [business_code, token, user]);

   //Function to gen the empty card to the transaction history 
   const EmptyCard = () => {
      return (
         <div className="m-3 w-auto ">
            <div className="border-history d-flex justify-content-md-center py-4 px-4 " aria-current="true">
               <div className="d-flex w-100 justify-content-center align-items-center  flex-column">
                  <img src={empty} alt="Vacio" width="35px" height="35px" />
                  <div className='text-center mt-3'>
                     <h5>Vacío</h5>
                     <h6 className="mb-0 text-secondary fw-bold">No hay transacciones </h6>
                  </div>
               </div>
            </div>
         </div>
      )
   }

   //We get the transactions by branchoffice 
   const getTransactionsByBranchOffice = async (business_code, branchoffice_code, minDate, maxDate) => {
      try {
         //We call the transaction info 
         const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(business_code, branchoffice_code, minDate, maxDate, 0, user.id, token, undefined, undefined, undefined, undefined);
         let data_orders = response.data.orders;
         let data_orders_Temporal = response.data.temp_orders

         let orders_Response = data_orders.filter(order =>
            userBranchoffices.some(branch => order.branchoffice.code === branch.code)
         );
         let orders_temporal_Response = data_orders_Temporal.filter(order =>
            userBranchoffices.some(branch => order.branchoffice.code === branch.code)
         );


         setBranchOrdersData(orders_Response);
         //This are for the discount temporal orders 
         setTemporalOrdersData(orders_temporal_Response);
         //This are for the search filter
         setTemporal(orders_Response);
      } catch (err) {
         //We show the error alert 
         ErrorAlert('No tiene información')
         console.log(err);
      }
   }

   //We get the temporal transactions by branchoffice 
   const getTemporalOrdersByBranch = async (business_code, branchoffice_code, minDate, maxDate, token) => {
      try {
         //We call the transaction info 
         const response = await OrdersFetchAPI.getTemporalOrdersByBranch(business_code, branchoffice_code, minDate, maxDate, token);
         //This are for the discount temporal orders 
         let data_orders_Temporal = response.data.temp_orders
         let orders_temporal_Response = data_orders_Temporal.filter(order =>
            userBranchoffices.some(branch => order.branchoffice.code === branch.code)
         );
         setTemporalOrdersData(orders_temporal_Response);

         //This are for the search filter
         //setTemporal(response.data.orders);
      } catch (err) {
         //We show the error alert 
         ErrorAlert('No tiene información')
         console.log(err);
      }
   }

   //get info brancoffice by id
   const getBranchofficebycode = async (branchoffice_code) => {
      try {
         const response = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code)
         setDataBranchoffice(response.data.branchoffice)
         return response.data.branchoffice;
      } catch (err) {
         console.log(err);
         setDataBranchoffice(0)
         return null;
      }
   }

   const actionSelectBranch = async (branchCode) => {
      const branchoffice = await getBranchofficebycode(branchCode);
      setSelectedBranch({ code: branchCode });
      getTransactionsByBranchOffice(business_code, branchCode, actualDate, actualDate + 'T23:59:59.000+00:00');
      getStoreStatusUberEats(branchoffice);
      getStoreStatusPedidosYa(branchoffice);
   }

   //update branchoffice
   const updateBranchoffice = async () => {


      let state = 0;
      if (dataBranchoffice.branchoffice_open === 0) { state = 1 }
      let data = { branchoffice_open: state }

      try {
         const response = await BranchOfficeFetchAPI.updateBranchoffice(dataBranchoffice.id, data, token);
         setchange_status(1)


      } catch (err) {
         console.log(err);
      }
   }


   //Function to update the store status on pedidosya
   const updateStoreStatusPedidosYa = async () => {
      try {
         //We get the integration params of pedidos ya
         const params = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(5, dataBranchoffice.id, token)
         //We set the params
         setPosIntegrationParams(params.data.params_values);
         try {
            //We get the integration params of pedidos ya
            let response = await PedidosYaFetchAPI.updateStoreStatus(dataBranchoffice.id, token);
            //We set the status 
            setPedidosYaStatus(response.data.status);
            //We show the success alert
            ErrorAlert('Estado de la tienda actualizado correctamente en pedidos ya', "Realizado", 'success');
         } catch (err) {
            //We show the error alert
            ErrorAlert('Error al actualizar el estado de la tienda en pedidos ya', "Advertencia", 'warning');
         }
      } catch (err) {
         console.log(err);
      }
   }

   //Function to get the status store on pedidosya
   const getStoreStatusPedidosYa = async (branchoffice = dataBranchoffice) => {
      if (!branchoffice || !branchoffice.id) return;
      try {
         //We get the integration params of pedidos ya
         const params = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(5, branchoffice.id, token)
         //We set the params
         setPosIntegrationParams(params.data.params_values);
         //We get the store status
         const response = await PedidosYaFetchAPI.getStoreStatus(branchoffice.id, token);
         //We check if the store is open or closed
         setPedidosYaStatus(response.data.data[0].availabilityState)
      } catch (err) {
         console.log(err);
         //We show the error alert
         setPedidosYaStatus("CLOSED")

      }
   }

   //Function to update the store status on UberEats
   const updateStoreStatusUberEats = async (status) => {
      try {
         //We get the integration params of UberEats
         const params = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(4, dataBranchoffice.id, token)
         //We set the params
         setPosIntegrationParams(params.data.params_values);
         try {
            //We get the integration params of UberEats
            let response = await UberEatsFetchAPI.updateStoreStatus(dataBranchoffice.id, status, token);
            //We set the status
            setUberEatsStatus(response.data.status);
            //We show the success alert
            ErrorAlert('Estado de la tienda actualizado correctamente en UberEats', "Realizado", 'success');
         } catch (err) {
            //We show the error alert
            ErrorAlert('Error al actualizar el estado de la tienda en UberEats', "Advertencia", 'warning');
         }
      } catch (err) {
         console.log(err);
      }
   }

   //Function to get the status store on UberEats
   const getStoreStatusUberEats = async (branchoffice = dataBranchoffice) => {
      if (!branchoffice || !branchoffice.id) return;
      try {
         //We get the integration params of UberEats
         const params = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(4, branchoffice.id, token)
         //We set the params
         setPosIntegrationParams(params.data.params_values);
         //We get the store status
         const response = await UberEatsFetchAPI.getStoreStatus(branchoffice.id, token);
         console.log(response);

         //We check if the store is open or closed
         setUberEatsStatus(response.data.status);
      } catch (err) {
         console.log(err);
         //We show the error alert
         setUberEatsStatus("OFFLINE")

      }
   }



   //Function to populate the list orders 
   const listOrders = () => {
      const listOrders = branchOrdersData.map((data) => (
         <>
            <div onClick={async () => {
               await getOrderById(data._id);
               handleShowModal();
            }}>
               <TransactionHistory data={data} />
            </div>
         </>
      ));
      //We check if the list orders has data 
      if (listOrders.length === 0) {
         return EmptyCard()
      } else {
         return (listOrders)
      }
   }

   //Function to populate the temporal list orders 
   const listTemporalOrders = () => {
      console.log(temporalOrdersData);
      const temporalOrders = temporalOrdersData.map((data) => (
         <>
            {data.status_id === 1 ? <>
               <div onClick={async () => {
                  await getTempOrderByCode(data.code);
                  handleShowModal();
               }} >
                  <TransactionPill data={data} />
               </div>
            </> : <></>}
         </>
      ));
      if (temporalOrders.length === 0) {
         return EmptyCard()
      } else {
         return (temporalOrders)
      }
   }

   //Function to populate the order details (modal)
   const detailOrderList = () => {
      return detailOrder === undefined ? "" : <OrderDetails temporalOrders={temporalOrdersData} setTemporalOrdersData={setTemporalOrdersData} orderData={detailOrder} order_type={order_type} business_data={userBusiness} setLoad={setReLoad} setModalShow={setModalShow} />
   }

   //Function to search any result on the search filter 
   const handleChangeFiltro = (event) => {
      let resultFilter = [];
      if (event.target.value === "") {
         console.log(event.target.value);
         setBranchOrdersData(temporal);
      } else {
         for (
            let recorrer = 0;
            recorrer < branchOrdersData.length;
            recorrer++
         ) {
            const examinar = branchOrdersData[recorrer];

            const info = JSON.stringify(examinar);
            const resultado = info
               .toLowerCase()
               .includes(event.target.value.toLowerCase());

            if (resultado === true) {
               resultFilter.push(examinar);

               setBranchOrdersData(resultFilter);
               console.log(resultFilter);
            }
         }
      }
   }

   //Function to get order by id (order_id)
   const getOrderById = async (order_id) => {
      try {
         const response = await OrdersFetchAPI.getOrderById(order_id, token);
         setDetailOrder(response.data.order)
         setOrderType("permanent")
      } catch (err) {
         console.log(err)
         // An empty object crashes OrderDetails (orderData.taxes.reduce) and leaves a white screen
         setDetailOrder(undefined)
         setOrderType("permanent")
         ErrorAlert(err?.response?.data?.error || err?.error || "No se pudo cargar el detalle de la transaccion")
      }
   }

   const normalizeApprovalOrder = (order, requestType) => {
      const inferredType = requestType || getApprovalRequestType(order);

      if (!inferredType) return order;

      return {
         ...order,
         is_discount_notification: inferredType === "Descuento",
         is_devolution_notification: inferredType === "Devolucion",
         _approval_request_type: inferredType,
      };
   }

   //Function to get a temporal order (for the espcial discounts notifications)
   const getTempOrderByCode = async (order_code, branchCode = selectedBranch.code, clearOnError = true, requestType) => {
      try {
         const response = await OrdersFetchAPI.getTempOrderByCode(order_code, business_code, branchCode, token);
         setDetailOrder(normalizeApprovalOrder(response.data.order, requestType))
         setOrderType("temporal")
         return response.data.order;
      } catch (err) {
         if (clearOnError) setDetailOrder(undefined)
         setOrderType("temporal")
         return null;
      }
   }

   useEffect(() => {
      setTemporalOrdersData([...temporalOrdersData]);
      setReLoad(0)
   }, [reload])

   //Hook to charge data when the page is need to be reloaded 
   useEffect(() => {
      (async () => {
         try {
            //We set the branchoffices of the user 
            setUserBranchs(user.branchoffices);
            //We set the business user 
            setUserBusiness(user.business);
            //We set the temporal data 
            setTemporalOrdersData(temporalOrdersData)
            //We set the branh orders data 
            setBranchOrdersData(branchOrdersData);
            setTemporal(branchOrdersData);
         } catch (err) {
            console.log(err);
         }
      })();
      //We set the load state 
      setReLoad(false)
      //We set the selected branch 
      setSelectedBranch(selectedBranch);
      //We get the transactions
      setPedidosYaStatus(pedidosYaStatus)
      localStorage.setItem('branchoffice_selected', selectedBranch.code);
      //We check if the integration of pedidos ya is active
      //if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 5) && selectedBranch.code !== 0) {
      //We get the store status on pedidos ya
      getStoreStatusPedidosYa();
      //}

      //We check if the integration of UberEats is active
      //if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 4) && selectedBranch.code !== 0) {
      console.log("UberEats Integration Active")
      //We get the store status on UberEats
      getStoreStatusUberEats();
      //}


   }, [reload, selectedBranch]);

   //Hook to conect the client to the sockets and make the initial charge of data 
   useEffect(() => {
      // Connection with the sockets server
      const socket = Socket({ "business_code": business_code })
      // we upate the data when the server send the signal of a new order 
      // Update of the data when the server send the signal of new order for this business 
      socket.on(`businessOrder_${business_code}`, (newOrder) => {
         const incomingOrder = unwrapSocketOrder(newOrder);
         let selected_branch = localStorage.getItem('branchoffice_selected')
         if (isApprovalOrder(incomingOrder)) {
            upsertTemporalOrder(incomingOrder);
            return;
         }
         //We set the branchoffice data order
         setBranchOrdersData((prevOrders) => {
            const incomingBranchCode = incomingOrder?.branchoffice?.code || incomingOrder?.branchoffice_code || incomingOrder?.branch_code;
            let index_user_branchoffices = user.branchoffices.findIndex(branch => String(incomingBranchCode) === String(branch.code));
            console.log(index_user_branchoffices)
            //We check that the new order is from any branch available to this user 
            if (index_user_branchoffices !== -1) {
               //We add the order if the order comes from an avalaible branch or a selected branc by the user
               if (selected_branch === 0 || selected_branch === '0' || String(selected_branch) === String(incomingBranchCode)) {
                  return [incomingOrder, ...prevOrders]
               }
            }
            return prevOrders;
         });
      });

      const tempOrderEvents = [
         `businessTempOrder_${business_code}`,
         `businessTemporalOrder_${business_code}`,
         `newBusinessTempOrder_${business_code}`,
         `newBusinessTemporalOrder_${business_code}`,
         `tempOrder_${business_code}`,
         `temporalOrder_${business_code}`,
      ];

      tempOrderEvents.forEach((eventName) => {
         socket.on(eventName, upsertTemporalOrder);
      });

      //Update of business temp orders when the temp order is deleted 
      socket.on(`deleteBusinessTempOrder_${business_code}`, (deletedTempOrder) => {
         removeTemporalOrder(deletedTempOrder);
         //We set the load state 
         setReLoad(true)
         //We close the modal 
         setModalShow(false)
      });

      return () => {
         tempOrderEvents.forEach((eventName) => {
            socket.off(eventName, upsertTemporalOrder);
         });
         socket.disconnect();
      }
   }, [business_code]);

   useEffect(() => {
      const approvalDeepLink = getApprovalDeepLinkParams();

      if (deepLinkHandled || !approvalDeepLink || !user || !Array.isArray(user.branchoffices)) return;

      const userCanAccessBranch = user.branchoffices.some(branch => String(branch.code) === String(approvalDeepLink.branchCode));

      if (!userCanAccessBranch) {
         setDeepLinkHandled(true);
         clearApprovalDeepLinkParams();
         ErrorAlert('No tiene acceso a la sucursal de esta solicitud', 'Advertencia', 'warning');
         return;
      }

      (async () => {
         setDeepLinkHandled(true);
         setSelectedBranch({ code: approvalDeepLink.branchCode });
         localStorage.setItem('branchoffice_selected', approvalDeepLink.branchCode);
         await getBranchofficebycode(approvalDeepLink.branchCode);
         await getTemporalOrdersByBranch(business_code, approvalDeepLink.branchCode, actualDate, actualDate + 'T23:59:59.000+00:00', token);
         const order = await getTempOrderByCode(approvalDeepLink.tempOrderCode, approvalDeepLink.branchCode);

         if (!order) {
            setModalShow(false);
            clearApprovalDeepLinkParams();
            ErrorAlert('Esta solicitud ya fue atendida o no esta disponible', 'Solicitud no disponible', 'warning');
            return;
         }


         handleShowModal();
      })();
   }, [business_code, deepLinkHandled, token, user]);

   //Hook to charge initial data hen the page is loaded 
   useEffect(() => {
      //We set the branchoffices of the user 
      setUserBranchs(user.branchoffices);
      //We set the business user 
      setUserBusiness(user.business);
      //We get the transactions
      getTemporalOrdersByBranch(business_code, selectedBranch.code, actualDate, actualDate + 'T23:59:59.000+00:00', token);
      localStorage.setItem('branchoffice_selected', 0);
      //We check if the integration of pedidos ya is active
      //if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 5) && selectedBranch.code !== 0) {
      //We get the store status on pedidos ya
      getStoreStatusPedidosYa();
      //}

      //We check if the integration of UberEats is active
      // if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 4) && selectedBranch.code !== 0) {
      console.log("UberEats Integration Active")
      //We get the store status on UberEats
      getStoreStatusUberEats();
      //}
   }, [business_code]);


   useEffect(() => {
      getBranchofficebycode(dataBranchoffice.code)
      setchange_status(0);
      //We check if the integration of pedidos ya is active
      //if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 5) && selectedBranch.code !== 0) {
         //We get the store status on pedidos ya
         getStoreStatusPedidosYa();
      //}

      //We check if the integration of UberEats is active
      //if (JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 4) && selectedBranch.code !== 0) {
         console.log("UberEats Integration Active")
         //We get the store status on UberEats
         getStoreStatusUberEats();
      //}
   }, [change_status]);

   return (
      <>
         <Navbar titlePage="Transacciones" route="transactions_panel" />

         <main className='bg-light-subtle pt-4 pb-5'>
            <div className='container'>

               <section className='banner-sp bg-light-subtle d-lg-flex justify-content-lg-between 
                  align-items-center rounded-4 mb-3 flex-column flex-lg-row justify-content-center py-2 py-lg-0'>


                  {/* Header Page */}
                  <div className='d-lg-flex flex-lg-stack flex-wrap gap-4 w-100 flex-nowrap d-flex justify-content-center align-items-center 
                  justify-content-lg-start '>
                     <div className='page-title d-flex flex-column gap-0 me-3'>
                        <h2 className='banner-reports-title mb-2 pb-0'>
                           Transacciones en smartpay

                           <RenderIf isTrue={dataBranchoffice !== 0}>

                              <input type="checkbox" className="btn-check" id="btn-check-outlined" autocomplete="off"
                                 checked={dataBranchoffice.branchoffice_open === 1 ? true : false} onChange={() => updateBranchoffice()} />

                              <label className={dataBranchoffice.branchoffice_open === 1 ? "" : ""} for="btn-check-outlined">
                                 {dataBranchoffice.branchoffice_open === 1 ? <>
                                    <small className="ms-1 mb-0  icon-on d-inline px-2 rounded-pill text-on  fw-normal small">Abierto <i className="uil uil-toggle-on"></i></small> </> :
                                    <><small className="ms-1  icon-off d-inline px-2 rounded-pill text-off fw-normal small">Cerrado <i className="uil uil-toggle-off"></i></small> </>}
                              </label>

                           </RenderIf>
                        </h2>
                        {/** PedidosYa Integration */}
                        <RenderIf isTrue={JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 5) && dataBranchoffice !== 0}>

                           <h2 className='banner-reports-title mb-2 pb-0'>
                              PedidosYa


                              <RenderIf isTrue={dataBranchoffice !== 0}>

                                 <input type="checkbox" className="btn-check" id="btn-check-outlined-pedidosya" autocomplete="off"
                                    checked={pedidosYaStatus === "OPEN" ? true : false} onChange={() => updateStoreStatusPedidosYa()} />

                                 <label className={pedidosYaStatus === "OPEN" ? "" : ""} for="btn-check-outlined-pedidosya">
                                    {pedidosYaStatus === "OPEN" ? <>
                                       <small className="ms-1 mb-0  icon-on d-inline px-2 rounded-pill text-on  fw-normal small">Abierto <i className="uil uil-toggle-on"></i></small> </> :
                                       <><small className="ms-1  icon-off d-inline px-2 rounded-pill text-off fw-normal small">Cerrado <i className="uil uil-toggle-off"></i></small> </>}
                                 </label>

                              </RenderIf>
                           </h2>
                        </RenderIf>

                        {/** UberEats Integration */}
                        <RenderIf isTrue={JSON.parse(localStorage.getItem("user")).business.posIntegrations.find(integration => integration.pos_integration_id === 4) && dataBranchoffice !== 0}>

                           <h2 className='banner-reports-title mb-2 pb-0'>
                              UberEats


                              <RenderIf isTrue={dataBranchoffice !== 0}>

                                 <input type="checkbox" className="btn-check" id="btn-check-outlined-ubereats" autocomplete="off"
                                    checked={uberEatsStatus === "ONLINE" ? true : false} onChange={() => updateStoreStatusUberEats(uberEatsStatus === "ONLINE" ? "OFFLINE" : "ONLINE")} />

                                 <label className={uberEatsStatus === "ONLINE" ? "" : ""} for="btn-check-outlined-ubereats">
                                    {uberEatsStatus === "ONLINE" ? <>
                                       <small className="ms-1 mb-0  icon-on d-inline px-2 rounded-pill text-on  fw-normal small">Abierto <i className="uil uil-toggle-on"></i></small> </> :
                                       <><small className="ms-1  icon-off d-inline px-2 rounded-pill text-off fw-normal small">Cerrado <i className="uil uil-toggle-off"></i></small> </>}
                                 </label>

                              </RenderIf>
                           </h2>
                        </RenderIf>

                        <p className='m-0 pt-1 banner-reports-description'>Transacciones diarias de pagos en tiempo real.</p>
                     </div>


                  </div>

                  {/* End Header Page */}


                  {/*<form className='filter-sp-trn'>
                     <div className="d-block">
                        <select onChange={e => {actionSelectBranch(e.target.value)  }} className='form-select' name="user_branch" id="user_branch">
                           <option value={0}> Mostrar todos</option>
                           {branchList()}
                        </select>
                     </div>
                  </form>*/}

                  <div className='d-lg-flex flex-lg-stack flex-wrap gap-4 w-100 flex-nowrap d-flex justify-content-center align-items-center 
                  justify-content-lg-end mt-3 mt-lg-0'>
                     <ModalBranchofficeSelect actionSelectBranch={actionSelectBranch}></ModalBranchofficeSelect>
                  </div>


               </section>

               <section className='row '>
                  <article className='col-12 col-lg-6'>

                     <div className='rounded-3 '>
                        <div className='border rounded-4 bg-white'>
                           <div className='p-lg-2 p-3'>
                              <div className='d-flex justify-content-between align-items-center mb-2 w-100'>
                                 <h4 className='banner-sp-subtitle'>Descuento/Devoluciones</h4>

                                 <button className='btn-ht-update btn bg-primary-subtle rounded-circle p-2 lh-1 border-primary' title="Actualizar Lista"
                                    onClick={e => getTemporalOrdersByBranch(business_code, selectedBranch.code, actualDate, actualDate + 'T23:59:59.000+00:00', token)} >
                                    {/* <img src={update} alt="Update List" width="16" height="16" /> */}
                                    <img className='' width="25" height="25" src={update} alt="restart" />
                                    {/* <small> Actualizar </small> */}
                                 </button>
                              </div>
                              <div className='transaction-wrapper border border-history no-scroll'>
                                 {listTemporalOrders()}
                              </div>
                           </div>

                        </div>
                     </div>
                  </article>


                  <article className='col-12 col-lg-6 mt-lg-0 mt-4'>
                     <div className='rounded-3'>
                        <div className='border rounded-4 bg-white'>
                           <div className=' p-lg-2 p-3'>
                              <div className='d-flex justify-content-between align-items-center mb-2'>
                                 <h4 className='banner-sp-subtitle'>Historial de Transacciones</h4>

                                 <div className='border-0 fw-bold fs-3 mx-1  w-50'>
                                    <input
                                       spellcheck="false"
                                       className="form-control w-100"
                                       type="text"
                                       step="any"
                                       onChange={handleChangeFiltro}
                                       placeholder="Filtrar por...  "
                                    />
                                 </div>


                                 <button className='btn-ht-update btn bg-primary-subtle rounded-circle p-2 lh-1 border-primary' title="Actualizar Lista"
                                    onClick={e => getTransactionsByBranchOffice(business_code, selectedBranch.code, actualDate, actualDate + 'T23:59:59.000+00:00')} >
                                    {/* <img src={update} alt="Update List" width="16" height="16" /> */}
                                    <img className='' width="25" height="25" src={update} alt="restart" />
                                    {/* <small> Actualizar </small> */}
                                 </button>
                              </div>
                              <div className='transaction-wrapper  border border-history  no-scroll mx-lg-0'>
                                 {listOrders()}
                              </div>
                           </div>
                        </div>
                     </div>
                  </article>
               </section>
            </div>
         </main>


         {/* Modal */}
         <Modal show={modalShow} onHide={handleCloseModal} size='lg' >
            <Modal.Body>
               {detailOrderList()}
            </Modal.Body>
         </Modal >
         {/* Footer */}
         <Footer />

      </>
   )
}

export default Transactions
